import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class PosToastrService {
  pos:string;
  constructor(public _translateService: TranslateService) { }
  displayLang() {
    switch (this._translateService.currentLang) {
      case 'fr' :this.pos = 'toast-top-right'; break;
      case 'en' :this.pos = 'toast-top-right'; break;
      case 'ar' :this.pos = 'toast-top-left'; break;
      case 'tn' :this.pos = 'toast-top-left'; break;
    } 
    return this.pos;
  }
}
